"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const d3 = __importStar(require("d3"));
const Sample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Sample"));
const Group_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Group"));
const ActiveElement_1 = require("@becrop/components/Toolkit/Heatmap2/models/ActiveElement");
const axios_1 = __importDefault(require("axios"));
class D3Reactive {
    constructor(select) {
        this.select = select;
    }
    static removeAll() {
        this.reactives.forEach((r) => r.remove());
        this.reactives = [];
    }
    static new(select) {
        const d3r = new D3Reactive(select);
        this.reactives.push(d3r);
        return d3r;
    }
    remove() {
        clearInterval(this.interval);
    }
    render(fn) {
        fn(this.select);
        this.interval = setInterval(() => {
            fn(this.select);
        }, 600);
    }
}
D3Reactive.reactives = [];
//
// General Configuration
//
const MAX_ITEM_SIZE = 36;
const BETWEEN = 4;
const HEIGHT_SAMPLES = 60;
const CIRCLE_HOOK_RADIUS = 10;
const PADDING_CELLS = 0.1;
const MARGIN = { top: 220, right: 50, bottom: 120, left: 0 };
const PADDING_INTER_LEVELS_H = 40;
const PADDING_INTER_LEVELS_V = 60;
const STANDARD_COLORS = [
    '#CECDCC',
    '#fac940',
    '#f4d58a',
    '#c3dcf0',
    '#85c5fa',
    '#1787e5',
];
const HEALTH_COLORS = ['#CECDCC', '#E6D581', '#EFCF32', '#FF9A51', '#E47C79', '#E52721'];
const ranksText = [
    (0, trans_1.trans)('toolkit.heatmap.leg_nd'),
    (0, trans_1.trans)('toolkit.heatmap.leg_vl'),
    (0, trans_1.trans)('toolkit.heatmap.leg_l'),
    (0, trans_1.trans)('toolkit.heatmap.leg_m'),
    (0, trans_1.trans)('toolkit.heatmap.leg_h'),
    (0, trans_1.trans)('toolkit.heatmap.leg_vh'),
];
//
// Global variables
//
let gHeatmap = null;
let gIsHorizontal = true;
let gScaleSamples;
let gScaleRanks;
let gIsDragging = false;
let gRanks = null;
let gColorsToUse = STANDARD_COLORS;
let gCells = [];
let gHooks = [];
function raiseRecursively(elem) {
    let parent = elem.parentNode;
    let pSelect = d3.select(parent);
    pSelect.raise();
    if (!parent.parentNode)
        return;
    parent = parent.parentNode;
    pSelect = d3.select(parent);
    if (!pSelect.classed('group'))
        return;
    d3.select(parent).raise();
    if (!parent.parentNode)
        return;
    parent = parent.parentNode;
    pSelect = d3.select(parent);
    if (!pSelect.classed('group'))
        return;
    d3.select(parent).raise();
}
class Cell {
    constructor(elem, sample, parent, idx, rank_name, value) {
        this.enabled = false;
        this.selected = false;
        this.elem = elem;
        this.sample = sample;
        this.parent = parent;
        this.idx = idx;
        this.rank_name = rank_name;
        this.value = value;
        this.draw();
    }
    enable() {
        this.enabled = true;
        const self = this;
        d3.select(this.elem)
            .on('click', function (e, x) {
            self.onClick();
        })
            .on('mouseover', function (e, x) {
            self.onMouseOver();
        })
            .on('mouseout', function (e, x) {
            self.onMouseOut();
        });
    }
    disable() {
        this.unSelect();
        this.enabled = false;
        d3.select(this.elem).on('click', null).on('mouseover', null).on('mouseout', null);
    }
    draw() {
        const rect = d3.select(this.elem).select('rect');
        rect.style('transform-box', 'fill-box')
            .style('transform-origin', 'center')
            .attr('rx', 4)
            .attr('ry', 4)
            .attr('width', MAX_ITEM_SIZE)
            .attr('height', MAX_ITEM_SIZE)
            .attr('x', () => {
            if (gIsHorizontal) {
                return 0;
            }
            else {
                return gScaleSamples(this.idx);
            }
        })
            .attr('y', () => {
            if (gIsHorizontal) {
                return gScaleSamples(this.idx);
            }
            else {
                return 0;
            }
        })
            .style('fill-opacity', () => {
            if (this.value === null)
                return '0';
            else
                return '1';
        })
            .style('fill', () => {
            if (this.value === null)
                return '';
            return gColorsToUse[this.value];
        });
        this.drawReset(rect);
    }
    drawReset(rect) {
        rect.style('stroke-dasharray', () => {
            if (this.value === null || isNaN(this.value))
                return 4;
            else
                return 'none';
        }).style('stroke', () => {
            if (this.value === null || isNaN(this.value))
                return '#555555';
            else
                return 'none';
        });
    }
    onMouseOver() {
        raiseRecursively(this.elem.parentNode);
        d3.select(this.elem)
            .raise()
            .select('rect')
            .transition()
            .duration(500)
            .style('transform', 'scale(1.5)')
            .style('stroke', () => this.parent.color);
    }
    onMouseOut() {
        const rect = d3.select(this.elem).select('rect');
        const xx = rect.transition().duration(500).style('transform', 'scale(1)');
        if (this.selected)
            return;
        this.drawReset(xx);
    }
    onClick() {
        if (this.selected) {
            this.unSelect();
        }
        else {
            this.select();
        }
    }
    select() {
        this.selected = true;
        gCells.filter((c) => c !== this).forEach((c) => c.unSelect());
        gHeatmap.activeElement = new ActiveElement_1.ActiveCell(this.rank_name, this.value, this.sample, this.parent);
    }
    unSelect() {
        this.selected = false;
        this.onMouseOut();
    }
}
class Hook {
    constructor(elem, parent, item) {
        this.enabled = false;
        this.selected = false;
        this.elem = elem;
        this.parent = parent;
        this.item = item;
    }
    selectParent() {
        const parent = this.elem.parentNode;
        return d3.select(parent);
    }
    selectContainer() {
        const parent = this.elem.parentNode.parentNode;
        return d3.select(parent);
    }
    disable() {
        this.enabled = false;
        d3.select(this.elem).attr('hidden', true).attr('hidden', true);
        const parent = this.elem.parentNode;
        d3.select(parent)
            .on('.drag', null)
            .on('click', null)
            .on('mousedown', null)
            .on('mouseover', null)
            .on('mouseout', null);
    }
    enable() {
        this.enabled = true;
        d3.select(this.elem)
            .attr('hidden', null) //to show
            .style('opacity', 0);
        const parent = this.elem.parentNode;
        d3.select(parent)
            .style('cursor', 'pointer')
            .on('click', () => this.onMouseClick())
            .on('mousedown', () => this.onMouseClick())
            .on('mouseover', () => this.onMouseOver())
            .on('mouseout', () => this.onMouseOut())
            .call(d3
            .drag()
            .on('start', (ev) => this.onDragStart(ev))
            .on('drag', (ev) => this.onDrag(ev))
            .on('end', (ev) => this.onDragEnd(ev)));
    }
    raiseRecursively() {
        raiseRecursively(this.elem);
    }
    onDragStart(event) {
        if (!this.enabled)
            return;
        d3.select(this.elem).style('cursor', 'grabbing');
        this.d3_sibblings = this.selectContainer().selectChildren('.sample,.group');
        this.raiseRecursively();
        gIsDragging = true;
    }
    onDrag(event) {
        if (!this.enabled)
            return;
        // Select the others
        gHooks.filter((h) => h !== this).forEach((h) => h.unSelect());
        const myWidth = this.parent.childWidth(this.item);
        const pixelWidth = gScaleSamples(myWidth);
        this.selectParent().attr('transform', () => {
            if (gIsHorizontal) {
                const x = event.x - pixelWidth / 2;
                return `translate(${x}, 10)`;
            }
            else {
                const y = event.y - pixelWidth / 2;
                return `translate(10, ${y})`;
            }
        });
        //
        const middles = [];
        for (let i = 0; i < this.parent.length; i++) {
            const child = this.parent.child(i);
            const offset = this.parent.childOffset(child);
            const width = this.parent.childWidth(child);
            const mid = offset + width / 2;
            middles.push(gScaleSamples(mid));
        }
        const myPos = (gIsHorizontal ? event.x : event.y) - gScaleSamples(myWidth / 2);
        let newIdx = 0;
        for (let i = 0; i < middles.length; i++) {
            newIdx = i;
            if (middles[i] > myPos)
                break;
        }
        const myIdx = this.parent.childIdx(this.item);
        if (myIdx === newIdx)
            return;
        this.parent.moveChild(myIdx, newIdx);
        const self = this;
        this.d3_sibblings
            .filter((c) => c !== this.item)
            .transition()
            .duration(300)
            .attr('transform', function (c) {
            const idx = self.parent.childOffset(c);
            if (gIsHorizontal) {
                const x = gScaleSamples(idx);
                return `translate(${x} 0)`;
            }
            else {
                const y = gScaleSamples(idx);
                return `translate(0 ${y})`;
            }
        });
    }
    onDragEnd(event) {
        if (!this.enabled)
            return;
        d3.select(this.elem).style('cursor', 'pointer');
        const self = this;
        this.d3_sibblings.attr('transform', function (c) {
            const idx = self.parent.childOffset(c);
            if (gIsHorizontal) {
                const x = gScaleSamples(idx);
                return `translate(${x} 0)`;
            }
            else {
                const y = gScaleSamples(idx);
                return `translate(0 ${y})`;
            }
        });
        gIsDragging = false;
    }
    onMouseOver() {
        if (gIsDragging)
            return;
        d3.select(this.elem).transition().duration(500).style('opacity', 1);
    }
    onMouseOut() {
        if (this.selected)
            return;
        d3.select(this.elem).transition().duration(500).style('opacity', 0);
    }
    onMouseClick() {
        if (this.selected) {
            this.unSelect();
        }
        else {
            this.select();
        }
    }
    select() {
        this.selected = true;
        gHooks.filter((h) => h !== this).forEach((c) => c.unSelect());
        if (this.item instanceof Sample_1.default) {
            gHeatmap.activeElement = new ActiveElement_1.ActiveSample(this.item, this.parent);
        }
        else {
            gHeatmap.activeElement = new ActiveElement_1.ActiveGroup(this.item);
        }
    }
    unSelect() {
        this.selected = false;
        this.onMouseOut();
    }
}
let HeatmapChart = class HeatmapChart extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.width = 0;
        this.height = 0;
        this.colorGroups = [
            '#d98e7a',
            '#3fb8b2',
            '#6C3FB8',
            '#DB756F',
            '#CF8944',
            '#E6C93B',
            '#3D9970',
            '#85144b',
            '#FF851B',
            '#39CCCC',
            '#01FF70',
            '#FFDC00',
            '#001f3f',
            '#0074D9',
        ];
        this.d3SampleTitles = [];
    }
    toggleFullScreen() {
        // @ts-ignore
        this.$refs['fullscreen'].toggle();
    }
    tweakZoomLevel() {
        if (!this.heatmapZoomNeedsUpdate)
            return;
        var t = this.mainGElement.attr('transform');
        let x = 0;
        let y = 0;
        let s = 1;
        if (t) {
            var reg = new RegExp(/translate\(\s*([0-9\.\,\s)]+)\)/g);
            var value = t.replace(reg, function (a, b, c) {
                return b;
            });
            let val = value.split(/[\s,]+/);
            x = parseInt(val[0].substr(val[0].indexOf('(') + 1));
            y = parseInt(val[1]);
            s = parseFloat(val[2].substr(val[2].indexOf('(') + 1));
        }
        this.svgElement
            .transition()
            .duration(750)
            .call(this.zoom.transform, d3.zoomIdentity.translate(x, y).scale(s + this.heatmapZoomLevel));
        this.$emit('zoomupdated');
    }
    onChangeRefreshHeatmap() {
        this.heatmap.need_refresh && this.refreshHeatmap();
    }
    refreshHeatmap() {
        this.drawHeatmap();
        this.$emit('heatmaprefreshed');
    }
    onChangeZoom() {
        if (this.heatmap.modifiedZoom)
            return;
        this.resetZoom();
    }
    resetZoom() {
        if (!this.zoom)
            return;
        this.svgElement
            .transition()
            .duration(750)
            .call(this.zoom.transform, d3.zoomIdentity);
    }
    drawSampleTitles() {
        this.d3SampleTitles.forEach((titles) => titles.text((s) => {
            return this.heatmap.optionDisplay === 'code' ? s.code : s.name;
        }));
    }
    drawHeatmap() {
        D3Reactive.removeAll();
        gHeatmap = this.heatmap;
        gHooks = [];
        gCells = [];
        this.d3SampleTitles = [];
        this.heatmap.modifiedZoom = false;
        const htmlHeatmap = this.$refs['d3-heatmap'];
        //
        // Get the Heatmap Ranks
        //
        gRanks = this.heatmap.getHeatmapRanks();
        if (gRanks.colorStyle === 'health') {
            gColorsToUse = HEALTH_COLORS;
        }
        else {
            gColorsToUse = STANDARD_COLORS;
        }
        const numSamples = gRanks.flatSamples.length;
        const numRanks = gRanks.ranks.length;
        const sizeSamples = (1 + PADDING_CELLS / 2) * MAX_ITEM_SIZE * numSamples;
        const sizeRanks = (1 + PADDING_CELLS / 2) * MAX_ITEM_SIZE * numRanks;
        gIsHorizontal = this.heatmap.optionOrientation === 'horizontal';
        this.width = gIsHorizontal ? sizeSamples : sizeRanks;
        this.height = gIsHorizontal ? sizeRanks : sizeSamples;
        gScaleSamples = d3.scaleLinear().domain([0, numSamples]).range([0, sizeSamples]);
        gScaleRanks = d3.scaleLinear().domain([0, numRanks]).range([0, sizeRanks]);
        //
        // Basic Layout with Axis
        //
        this.svgElement = d3
            .select(htmlHeatmap)
            .append('svg')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('class', 'heatmapsvg');
        this.mainGElement = this.svgElement
            .append('g')
            .attr('data-name', 'all')
            .attr('transform', 'translate(' + MARGIN.left + ',' + MARGIN.top + ')')
            .append('g')
            .attr('data-name', 'main');
        const rankAxis = this.mainGElement
            .append('g')
            .attr('class', 'rank-axis')
            .selectAll('.rank-axis-item')
            .data(gRanks.ranks)
            .enter()
            .append('g')
            .attr('class', 'rank-axis-item')
            .style('font-size', 10);
        rankAxis
            .append('text')
            .text((r) => r.name)
            .attr('class', 'noselect--text');
        if (gIsHorizontal) {
            rankAxis.attr('text-anchor', 'end').attr('transform', (rank, i) => {
                const y = gScaleRanks(i + 0.5);
                return `translate(-10, ${y})`;
            });
        }
        else {
            rankAxis
                .style('text-anchor', 'start')
                .attr('transform', (rank, i) => {
                let x = gScaleRanks(i + 0.5);
                return `translate(${x}, -10) rotate(-90)`;
            })
                .attr('dy', '-2em');
        }
        const svg_root = this.mainGElement.append('g').attr('data-name', 'root');
        this.drawGroup(svg_root, this.heatmap.root);
        this.drawLegend(svg_root, numRanks, numSamples, gIsHorizontal);
        //
        // Add transparent background
        //
        this.mainGElement
            .append('rect')
            .attr('class', 'background')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('fill', 'transparent')
            .lower();
        this.onChangeFocus();
    }
    drawGroup(g, group) {
        if (group.samples) {
            this.drawSamples(g, group, group.samples);
        }
        if (group.groups) {
            this.drawGroups(g, group, group.groups);
        }
    }
    drawGroups(g, parent, groups) {
        const d3_groups = g
            .selectAll('.group')
            .data(groups)
            .enter()
            .append('g')
            .attr('class', 'group')
            .attr('transform', (g) => {
            const idx = parent.childOffset(g);
            let x = 0, y = 0;
            if (gIsHorizontal) {
                x = gScaleSamples(idx);
            }
            else {
                y = gScaleSamples(idx);
            }
            return `translate(${x},${y})`;
        });
        const d3_groups_hierarchy = d3_groups
            .append('g')
            .attr('class', 'hierarchy hierarchy__group')
            .attr('transform', (g) => {
            const maxLevels = this.heatmap.root.maxLevel();
            const relativeLevel = maxLevels - parent.level;
            let x = 0, y = 0;
            if (gIsHorizontal) {
                y = this.height;
                y += PADDING_INTER_LEVELS_H * relativeLevel;
            }
            else {
                x = this.width;
                x += PADDING_INTER_LEVELS_V * relativeLevel;
            }
            return `translate(${x},${y})`;
        });
        const rects = d3_groups_hierarchy.append('rect').attr('fill', (g) => g.color);
        D3Reactive.new(rects).render((rects) => rects.attr('fill', (g) => g.color));
        const rectSize = (g) => gScaleSamples(g.numSamplesRecursive()) - (gScaleSamples(1) - MAX_ITEM_SIZE);
        if (gIsHorizontal) {
            rects.attr('width', rectSize).attr('height', 1);
        }
        else {
            rects.attr('width', 1).attr('height', rectSize);
        }
        const texts = d3_groups_hierarchy
            .append('text')
            .style('font-size', 10)
            .text((g) => g.name)
            .attr('class', 'noselect--text')
            .attr('transform', (g) => {
            let transfStr;
            if (gIsHorizontal) {
                transfStr = `translate(0,15) rotate(15)`;
            }
            else {
                transfStr = `translate(5,0) rotate(10)`;
            }
            return transfStr;
        });
        D3Reactive.new(texts).render((groups) => groups.text((g) => g.name));
        if (gIsHorizontal) {
            texts.attr('y', -10).attr('dy', '.5em');
        }
        else {
            texts.attr('x', 5).attr('dy', '1em');
        }
        const self = this;
        d3_groups.each(function (group) {
            const elem = d3.select(this);
            self.drawGroup(elem, group);
            self.drawHook(elem, parent, group);
        });
    }
    drawSamples(g, parent, samples) {
        const d3_samples = g
            .selectAll('.sample')
            .data(samples)
            .enter()
            .append('g')
            .attr('class', 'sample')
            .attr('transform', (s) => {
            const idx = parent.childOffset(s);
            let x = 0, y = 0;
            if (gIsHorizontal) {
                x = gScaleSamples(idx);
            }
            else {
                y = gScaleSamples(idx);
            }
            return `translate(${x}, ${y})`;
        });
        //
        // Add the text for the samples
        //
        const d3SampleTitles = d3_samples
            .append('text')
            .style('font-size', 10)
            .style('transform-box', 'fill-box')
            .attr('class', 'noselect--text');
        if (gIsHorizontal) {
            d3SampleTitles
                .style('text-anchor', 'start')
                .attr('dy', '.5em')
                .attr('transform', 'translate(10, -5) rotate(-90)');
        }
        else {
            d3SampleTitles
                .style('text-anchor', 'end')
                .attr('dx', '-1em')
                .attr('dy', '20px');
        }
        this.d3SampleTitles.push(d3SampleTitles);
        this.drawSampleTitles();
        this.drawCells(parent, d3_samples);
        const self = this;
        d3_samples.each(function (sample) {
            const elem = d3.select(this);
            self.drawHook(elem, parent, sample);
        });
    }
    drawCells(parent, d3_samples) {
        const d3_cells = d3_samples
            .append('g')
            .attr('class', 'cells__set')
            .selectAll('.cell')
            .data((s) => {
            return gRanks.getValues(s).map((v, i) => {
                return {
                    sample: s,
                    value: v,
                    rank_name: gRanks.ranks[i].name,
                };
            });
        })
            .enter()
            .append('g')
            .attr('class', 'cell');
        d3_cells.append('rect');
        const self = this;
        d3_cells.each(function ({ sample, value, rank_name }, i) {
            const cell = new Cell(this, sample, parent, i, rank_name, value);
            gCells.push(cell);
        });
    }
    drawLegend(g, numRanks, numSamples, gIsHorizontal) {
        const itemWidth = 70;
        const padding = 1.25;
        const d3_legend = g
            .append('g')
            .attr('class', 'legend')
            .style('pointer-events', 'none')
            .style('opacity', '0');
        for (let i = 0; i < gColorsToUse.length; i++) {
            d3_legend
                .append('circle')
                .attr('r', '3px')
                .attr('rx', 0)
                .attr('ry', 0)
                .attr('fill', gColorsToUse[i])
                .attr('transform', () => {
                let y = 0;
                gIsHorizontal
                    ? (y = gScaleRanks(numRanks + padding) + 100)
                    : (y = gScaleSamples(numSamples + padding / 2));
                let x = 0 + i * itemWidth;
                return `translate(${x}, ${y})`;
            });
            d3_legend
                .append('text')
                .style('font-size', '8px')
                .attr('x', 0)
                .attr('y', 0)
                .attr('transform', () => {
                let y = 0;
                gIsHorizontal
                    ? (y = gScaleRanks(numRanks + padding) + 3 + 100)
                    : (y = gScaleSamples(numSamples + padding / 2) + 3);
                let x = 0 + i * itemWidth + 7;
                return `translate(${x}, ${y})`;
            })
                .text((0, trans_1.trans)('toolkit.heatmap.' + i));
        }
    }
    onChangeFocus() {
        //
        // groups, subgroups, samples
        //
        let maxLevel = this.heatmap.root.maxLevel();
        let level = -1;
        switch (this.heatmap.selectedFocus) {
            case 'samples':
                level = maxLevel;
                break;
            case 'groups':
                level = maxLevel === 0 ? -1 : 0;
                break;
            case 'subgroups':
                level = maxLevel != 2 ? -1 : 1;
                break;
        }
        gHooks.forEach((h) => h.disable());
        gHooks.filter((h) => h.parent.level === level).forEach((h) => h.enable());
        //
        // Cells
        //
        gCells.forEach((c) => c.disable());
        if (this.heatmap.selectedFocus === 'cells') {
            gCells.forEach((c) => c.enable());
        }
        //
        // Zoom
        //
        const svg = this.svgElement;
        const g = this.mainGElement;
        // Remove old events
        svg.on('.zoom', null);
        // Attach a new zoom behaviour
        if (this.heatmap.selectedFocus === 'zoom') {
            this.zoom = d3
                .zoom()
                .scaleExtent([0.2, 8])
                .on('zoom', (event) => {
                this.heatmap.modifiedZoom = true;
                g.attr('transform', event.transform);
            });
            svg.call(this.zoom);
        }
    }
    drawHook(g, parent, item) {
        const d3_hook = g
            .append('g')
            .attr('class', 'hook')
            .attr('transform', () => {
            let x = 0, y = 0;
            if (gIsHorizontal) {
                y = -HEIGHT_SAMPLES;
            }
            else {
                x = -HEIGHT_SAMPLES;
            }
            return `translate(${x},${y})`;
        })
            .style('opacity', 0);
        const num = item instanceof Group_1.default ? item.numSamplesRecursive() : 1;
        const sizeSamples = gScaleSamples(num) - (gScaleSamples(1) - MAX_ITEM_SIZE);
        const numRanks = gRanks.ranks.length;
        const sizeRanks = MAX_ITEM_SIZE * numRanks + BETWEEN * (numRanks + 2) + HEIGHT_SAMPLES;
        const color_fn = (item) => {
            if (item instanceof Group_1.default) {
                return item.color;
            }
            else {
                return parent.color;
            }
        };
        const rects = d3_hook
            .append('rect')
            .attr('rx', 4)
            .attr('ry', 4)
            .style('stroke', color_fn)
            .style('fill', color_fn)
            .style('fill-opacity', 0.3)
            .attr('width', gIsHorizontal ? sizeSamples : sizeRanks)
            .attr('height', gIsHorizontal ? sizeRanks : sizeSamples);
        D3Reactive.new(rects).render((rects) => rects.style('stroke', color_fn).style('fill', color_fn));
        const circles = d3_hook
            .append('g')
            .attr('class', 'hook__actions')
            .append('circle')
            .style('stroke', color_fn)
            .style('fill', '#ffffff')
            .attr('r', CIRCLE_HOOK_RADIUS)
            .attr('cx', () => {
            return gIsHorizontal ? sizeSamples / 2 : sizeRanks;
        })
            .attr('cy', () => {
            return gIsHorizontal ? sizeRanks : sizeSamples / 2;
        });
        D3Reactive.new(circles).render((rects) => rects.style('stroke', color_fn));
        /*d3_hook
            .select("g")
            .append("image")
            .attr("xlink:href", "/images/icon_hidden.svg")
            .attr("x", () => {
                return (gIsHorizontal ? sizeSamples : sizeRanks) /2;
            })
            .attr("y", () => {
                return gIsHorizontal ? sizeRanks : sizeSamples;
            })
            .attr("width", 14)
            .attr("height", 14)
            .attr("transform", "translate(-7, -7)")
            .on("click", function() {
                console.log("hide")
            })*/
        const hook = new Hook(d3_hook.node(), parent, item);
        gHooks.push(hook);
    }
    mounted() {
        this.drawHeatmap();
    }
    async onMustDownload() {
        const padding = 20;
        // https://graphicdesign.stackexchange.com/questions/5162/how-do-i-embed-google-web-fonts-into-an-svg
        const font = (await axios_1.default.get('/mix/fonts/BrandonText-Regular.otf', {
            responseType: 'blob',
        })).data;
        const blobToBase64 = (blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            });
        };
        const fontB64 = await blobToBase64(font);
        const cssText = `
            @font-face {
                font-family: "Brandon";
                src: url("${fontB64}");
            }
        `;
        const serializer = new XMLSerializer();
        const htmlHeatmap = this.$refs['d3-heatmap'];
        const svg = d3.select(htmlHeatmap).select('svg').clone(true);
        svg.select('.legend').style('opacity', '1');
        svg.selectAll('text').attr('font-family', 'Brandon');
        svg.append('style').text(cssText);
        svg.select('g').select('g').attr('transform', 'scale(2)');
        let width;
        let height;
        svg.select('g').attr('transform', null);
        //svg.select('.background').attr('fill', 'white');
        svg.style('background-color', 'white');
        const boundingSVG = svg.node().getBoundingClientRect();
        const boundingG = svg.select('g').node().getBoundingClientRect();
        let x, y;
        x = boundingSVG.x - boundingG.x;
        y = boundingSVG.y - boundingG.y;
        x += padding;
        y += padding;
        width = Math.ceil(boundingG.width);
        height = Math.ceil(boundingG.height);
        width += 2 * padding;
        height += 2 * padding;
        svg.selectAll('.hook').remove();
        svg.attr('width', width);
        svg.attr('height', height);
        svg.select('g').attr('transform', `translate(${x}, ${y})`);
        const xmlString = serializer.serializeToString(svg.node());
        svg.remove();
        this.heatmap.download_svg = {
            content: xmlString,
            width,
            height,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], HeatmapChart.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], HeatmapChart.prototype, "fsactive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], HeatmapChart.prototype, "heatmapZoomLevel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], HeatmapChart.prototype, "heatmapZoomNeedsUpdate", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fsactive')
], HeatmapChart.prototype, "toggleFullScreen", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmapZoomNeedsUpdate')
], HeatmapChart.prototype, "tweakZoomLevel", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.need_refresh')
], HeatmapChart.prototype, "onChangeRefreshHeatmap", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.modifiedZoom')
], HeatmapChart.prototype, "onChangeZoom", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.optionDisplay')
], HeatmapChart.prototype, "drawSampleTitles", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.selectedFocus')
], HeatmapChart.prototype, "onChangeFocus", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.download_idx')
], HeatmapChart.prototype, "onMustDownload", null);
HeatmapChart = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {},
    })
], HeatmapChart);
exports.default = HeatmapChart;
